module.exports = function (element) {
    function markBlock(el) {
        var node = $(el);
        var links = node.find("a[href^='#c']");
        var url = '/api/comment/vote/'

        links.on({
            click: function () {
                var id = parseInt($(this).attr("href").slice(2));
                var m = 1;

                if ($(this).attr("href").indexOf("bad") != -1)
                    m = -1;

                $.post(url, {'id': id, 'm': m}, function (data) {
                    $("#vote_comment_" + data.result.id).text(data.result.votings);
                }, 'json');

                $("a[href^='#c" + id + "']").addClass("disable");
                $(this).removeClass("disable");

                gtag('event', 'vote_comment_vote', {
                    'event_category': 'vote_comment',
                    'event_label': m
                });

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    markBlock(element);
};
